import {Component, Inject} from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {detailsExpand} from '../../../../common';

export enum SearchCriteriaControls {
  MemberIDNumber = 'Member ID Number',
  MemberLastName = 'Member Last Name',
  PolicyNumber = 'Membership Number',
  ReferenceNumber = 'Reference Number',
  TransactionIDs = 'Transaction IDs List',
  TransactionNumber = 'Transaction Number',
}

interface DialogData {
  [key: string]: boolean;
}

@Component({
  selector: 'app-activity-history-dialog',
  templateUrl: './claim-search-criteria-dialog.component.html',
  styleUrls: ['../../../../../../styles/global/_dialog-styles.scss'],
  animations: [detailsExpand]
})
export class ClaimSearchCriteriaDialogComponent {
  readonly controls = SearchCriteriaControls;
  controlKeys: string[] = Object.keys(SearchCriteriaControls);
  heading = 'Search Criteria Filters';
  formGroup: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<ClaimSearchCriteriaDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {
    this.formGroup = this.createForm();
  }

  createForm(): FormGroup {
    const formControls = {};
    Object
      .keys(SearchCriteriaControls)
      .forEach(key => {
        formControls[key] = new FormControl({
          value: this.data && this.data[key] ? this.data[key] : false,
          disabled: this.data?.isAllowedToEdit !== undefined && !this.data?.isAllowedToEdit
        });
      });
    return this.formBuilder.group(formControls);
  }

  onClickSave(): void {
    const formControls = {};
    Object.keys(SearchCriteriaControls).forEach(key => {
      formControls[key] = this.formGroup.get(key)?.value;
    });
    this.dialogRef.close(formControls);
  }

  onClickCancelDialog(): void {
    this.dialogRef.close(null);
  }
}
